module.exports = __webpack_public_path__ + "static/img/stim-logo.9cd51ec8.png";